// extracted by mini-css-extract-plugin
export default {"user":"user-Gfij","about":"about-E97R"};